import React from "react";
import "./dashboard.module.scss";
import { Navbar } from "../common/components";
import SummaryWidget from "./summary-tab";

const Dashboard = () => {
  return (
    <div style={{ fontFamily: 'Segoe UI' }}>
      <Navbar />
     <SummaryWidget />
    {/* <VegaChart/> */}
    </div>
  );
};

export default Dashboard;
